import React from 'react'

import { ApolloError } from '@apollo/client/core'

interface QueryStateProps {
  children: React.ReactNode
  emptyLabel?: string
  error: ApolloError | undefined
  errorLabel?: string
  isEmpty?: boolean
  loading: boolean
  loadingLabel?: string
}

export const QueryState: React.FC<QueryStateProps> = ({
  loading,
  error,
  isEmpty,
  children,
  emptyLabel = 'Nothing here yet',
  loadingLabel = 'Loading…',
  errorLabel = 'Something went wrong.',
}) => {
  if (loading) {
    return <div className="user-profile-query-state user-profile-query-state_loading">{loadingLabel}</div>
  }

  if (error) {
    return <div className="user-profile-query-state user-profile-query-state_error">{errorLabel}</div>
  }

  if (isEmpty) {
    return <div className="user-profile-query-state user-profile-query-state_empty">{emptyLabel}</div>
  }

  return <>{children}</>
}
